import React, { useEffect, useState } from 'react';
import './Main.css';
// import "../../../src/App.css";
import { Carousel } from 'react-bootstrap';
import Appconfig from '../../config/config'
import Helper from '../../helper';
import { useDispatch, useSelector } from 'react-redux';
import { getBanner } from '../../redux/slice/banner/bannerSlice';
import axios from 'axios';

const Main = (props) => {
  const userInfo = Helper();
  const [banner, setbanners] = useState();


  function getBanner() {
    var data = JSON.stringify({
      site_code: "P52",
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}banner/getDashboardBanner`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result == 0) {
        } else {
          // setBalance(response.data.resultData?.balance)
          // setExposure(response.data.resultData?.exposure)
          console.log('banner response', response?.data?.resultData);
          setbanners(response?.data?.resultData);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    getBanner();
    // if (userInfo) {

    //   useDispatch(getBanner({
    //     user_id: userInfo?.master_id,
    //   }));
    // }
  }, [userInfo])


  return (
    <div>
      {
        banner && banner?.length > 0 &&
        <>
          <Carousel>
            {banner && banner?.length > 0 && banner.map((ban, index) => (
              <Carousel.Item interval={5000} key={ban?.id}>
                <img src={`${Appconfig.apiUrl}banner/${ban.image_name}`} className="banner-images" alt="..." />
              </Carousel.Item>
            ))}
          </Carousel>
        </>
        // :
        // <>
        //   <Carousel>
        //     <Carousel.Item interval={8000}>
        //       <img src="./Images/247betfair2.webp" className="banner-images" alt="..." />
        //     </Carousel.Item>
        //     <Carousel.Item interval={8000}>
        //       <img src="./Images/banner2.webp" className="banner-images" alt="..." />
        //     </Carousel.Item>
        //     <Carousel.Item interval={8000}>
        //       <img src="./Images/banner3.webp" className="banner-images" alt="..." />
        //     </Carousel.Item>
        //   </Carousel>
        // </>
      }

    </div>
  );
};
export default Main;